export enum CodDistribuidora {
  SAESA = 'S',
  EDELAYSEN = 'E',
  LUZ_OSORNO = 'L',
  FRONTEL = 'F',
}
